import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    amount: Yup.string().required('مبلغ وام ضروری می باشد'),
    number: Yup.string().required('تعداد اقساط ضروری می باشد'),
    repayment_amount: Yup.string().required(
        'تعداد اقساط پرداخت شده ضروری می باشد'
    ),
})
